export default {
  is_exist: state => {
    return state.active_recommendation.hasOwnProperty('id')
  }
}
